"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentPlanProcedureGroup_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TreatmentPlan_1 = require("./TreatmentPlan");
var TreatmentPlanProcedureGroup_Factory = /** @class */ (function () {
    function TreatmentPlanProcedureGroup_Factory() {
    }
    TreatmentPlanProcedureGroup_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            GroupIndex: model.GroupIndex,
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TreatmentPlan: TreatmentPlan_1.TreatmentPlan_Factory.CreateIncoming(model.TreatmentPlan),
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    TreatmentPlanProcedureGroup_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            GroupIndex: model.GroupIndex,
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TreatmentPlan: TreatmentPlan_1.TreatmentPlan_Factory.CreateOutgoing(model.TreatmentPlan),
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    return TreatmentPlanProcedureGroup_Factory;
}());
exports.TreatmentPlanProcedureGroup_Factory = TreatmentPlanProcedureGroup_Factory;
